module.exports = __webpack_public_path__ + "img/icon_bb.aa0a1f41.png";